<template>
    <div id="app">
        <header class="tw-w-full tw-bg-white">
            <div class="tw-container tw-h-full tw-flex tw-items-center tw-justify-center lg:tw-justify-between">
                <img src="~@/assets/img/logo.svg">
                <p class="tw-hidden tw-text-right lg:tw-block">Formação Oficial <span>"Como criar uma Carteira de Investimento"</span> Deco Proteste Investe</p>
            </div>
        </header>

        <!-- This will be reaplced by the view defined in the router -->
        <router-view></router-view>

        <footer v-scroll-to="'form'">
            <div>
                <div class="tw-container tw-flex tw-justify-center tw-items-center">
                    <small class="tw-text-white tw-text-center tw-block">O Banco Invest S.A., é uma instituição registada no Banco de Portugal com o código 0014 e na Comissão de Mercado e Valores Mobiliários sob o n° 0141.</small>
                </div>
            </div>
            <hr>
            <div>
                <div class="tw-container">
                    <div class="tw-flex tw-flex-col tw-justify-center tw-items-center lg:tw-gap-5 lg:tw-flex-row">
                        <small class="tw-text-white tw-block">© {{new Date().getFullYear()}} BANCO INVEST - TODOS OS DIREITOS RESERVADOS</small>
                        <img src="~@/assets/img/footer.png" class="tw-block">
                    </div>
                </div>
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <Clarity/>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import axios from 'axios';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        Clarity,
        ModalContainer,
        Terms,
    },
    created() {
        const data = {
            url: 'bancoinvest.pt',
            pubid: this.$route.query.pubid || null,
            utm_source: this.$route.query.utm_source || null,
            utm_campaign: this.$route.query.utm_campaign || null,
            utm_medium: this.$route.query.utm_medium || null,
            utm_content: this.$route.query.utm_content || null,
            utm_term: this.$route.query.utm_term || null,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => {
                console.log(error.response.data);
            });
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
    },
};
</script>
<style>

</style>
